import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { isNullOrUndefined } from '@utils/utils';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import { useParams } from 'react-router-dom';
import CustomerMultiDemandDetail from '@components/obsolete/multi-demand/CustomerMultiDemandDetail.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {
}

const MultiDemandDetailPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();
  const { multiDemandGroupId } = useParams();

  if (isNullOrUndefined(multiDemandGroupId)) return <></>;

  return (
    <>
      <ResponsiveLayout title={tr(`MultiDemandDetail.multiDemandDetail`, `Multi Demand detail`)}>
        <CustomerMultiDemandDetail multiDemandGroupId={multiDemandGroupId} />
      </ResponsiveLayout>
    </>
  );
};

export default withAuthenticationRequired(MultiDemandDetailPage);
